<template>
  <div :key="model.id">
    <modal-form v-model="show" :showSubmit="false" textClose="Fechar" size="xl">
      <template v-slot:title> Html Body </template>
      <template v-slot:body>
        <core-grid
          modal
          flat
          ref="grid"
          :onRead="onRead"
          :addOption="false"
          :editOption="false"
          :deleteOption="false"
          :schema="schema"
        >
        </core-grid>
      </template>
    </modal-form>
    <modal-details title="Valor" ref="detalhes"></modal-details>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      model: {},
      schema: [{ value: 'htmlBody', text: 'Html Body' }]
    }
  },
  methods: {
    onRead: function (options) {
      const dto = this.model.id
      this.$api.EmailTemplate.Get(`GetById/${dto}`).then(function (response) {
        options.success([response])
      })
    },
    openModal (sender) {
      const th = this
      th.show = true
      th.model = {}
      if (sender) {
        th.model = sender
        th.ID = th.model.id
      } else th.ID = ''
    },
    refresh () {
      this.$refs.grid.refresh()
    },
    response (data) {
      if (data) {
        this.refresh()
      }
    }
  }
}
</script>
